import type { InstitutionLocationDto } from "@niutraan/shared-dto";
import { create } from "zustand";

interface InstitutionLocationState {
  // State
  locations: InstitutionLocationDto[];
  activeLocations: InstitutionLocationDto[];
  selectedLocation: InstitutionLocationDto | null;

  // Actions
  setLocations: (locations: InstitutionLocationDto[]) => void;
  setActiveLocations: (locations: InstitutionLocationDto[]) => void;
  setSelectedLocation: (location: InstitutionLocationDto | null) => void;

  // Reset state
  reset: () => void;
}

// Initial state
const initialState = {
  locations: [],
  activeLocations: [],
  selectedLocation: null,
};

export const useInstitutionLocationStore = create<InstitutionLocationState>(
  (set) => ({
    ...initialState,

    // Actions
    setLocations: (locations) => set({ locations }),
    setActiveLocations: (activeLocations) => set({ activeLocations }),
    setSelectedLocation: (selectedLocation) => set({ selectedLocation }),

    // Reset state
    reset: () => set(initialState),
  }),
);
